/**
 * Label + value with copy-to-clipboard control
 */

import React, { useState } from 'react'

export default function CopyableField({ label, value }) {
  const [copied, setCopied] = useState(false)
  const text = value == null || value === '' ? '—' : String(value)
  const canCopy = text !== '—'

  const copy = async () => {
    if (!canCopy) return
    try {
      await navigator.clipboard.writeText(text)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch {
      // ignore
    }
  }

  return (
    <div className="flex items-start gap-2 py-1.5 min-w-0">
      <div className="flex-1 min-w-0">
        <dt className="text-xs font-medium text-gray-500">{label}</dt>
        <dd className="text-sm text-gray-900 break-words">{text}</dd>
      </div>
      {canCopy && (
        <button
          type="button"
          onClick={copy}
          className="shrink-0 p-1.5 rounded-md text-gray-500 hover:text-green-700 hover:bg-green-50"
          title={copied ? 'Copied' : 'Copy'}
          aria-label={copied ? 'Copied' : `Copy ${label}`}
        >
          {copied ? (
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          ) : (
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
              />
            </svg>
          )}
        </button>
      )}
    </div>
  )
}
